import { render, staticRenderFns } from "./InstrumentsTable.vue?vue&type=template&id=22750196&"
import script from "./InstrumentsTable.vue?vue&type=script&lang=js&"
export * from "./InstrumentsTable.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports